import { Button as MuiButton, FormControl } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SizingWrapper, type ISizingWrapperProps } from "../Wrapper";
import { ButtonColorOption, type ButtonVariantOption } from "./Button";
import { isInternalLink } from "@/utils/link";

interface IProps {
  children: React.ReactNode;
  variant: ButtonVariantOption;
  href: string;
  size?: "small" | "medium" | "large";
  color?: ButtonColorOption;
  fullWidth?: boolean;
  disabled?: boolean;
  startIcon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  wrapperSize?: ISizingWrapperProps["size"];
  sx?: object;
  target?: string;
  rel?: string;
}

const LinkButton: React.FC<IProps> = (props) => {
  const {
    children,
    variant,
    color = ButtonColorOption.Primary,
    fullWidth = false,
    size = "medium",
    disabled = false,
    startIcon,
    type = "button",
    href,
    wrapperSize,
    sx,
    target,
    rel,
  } = props;

  // 内部リンクの場合はReact Routerを使用
  if (isInternalLink(href) && !target) {
    return (
      <SizingWrapper size={wrapperSize}>
        <FormControl fullWidth>
          <MuiButton
            component={RouterLink}
            to={href}
            variant={variant}
            color={color}
            fullWidth={fullWidth}
            disabled={disabled}
            startIcon={startIcon}
            type={type}
            size={size}
            sx={sx}
          >
            {children}
          </MuiButton>
        </FormControl>
      </SizingWrapper>
    );
  }

  // 外部リンクまたはtargetが指定されている場合は従来通り
  return (
    <SizingWrapper size={wrapperSize}>
      <FormControl fullWidth>
        <MuiButton
          variant={variant}
          color={color}
          fullWidth={fullWidth}
          disabled={disabled}
          startIcon={startIcon}
          type={type}
          href={href}
          size={size}
          sx={sx}
          target={target}
          rel={rel}
        >
          {children}
        </MuiButton>
      </FormControl>
    </SizingWrapper>
  );
};

export { LinkButton };
